export const useToast = defineStore('toast', () => {
  const showSnackbar = ref(false)
  const responseCode = ref(0)
  const responseMessage = ref('')
  const toastTimeout = ref(3000)
  const toastTimer = ref(false)
  const toastLink = ref('')
  const toastLinkText = ref('Clique para acessar ')

  function reset() {
    showSnackbar.value = false
    responseCode.value = 0
    responseMessage.value = ''
    toastTimeout.value = 3000
    toastTimer.value = false
    toastLink.value = ''
    toastLinkText.value = 'Clique para acessar '
  }

  function alert(
    message: string,
    code: number,
    timeout?: number,
    link?: string,
    linkText?: string,
  ) {
    responseCode.value = code ?? 0
    responseMessage.value = message
    toastTimeout.value = timeout ?? 3000
    toastLink.value = link ?? ''
    toastLinkText.value = linkText ?? 'Clique para acessar '
    showSnackbar.value = true
  }

  function success(message: string) {
    alert(message, 200)
  }

  function error(message: string) {
    alert(message, 500)
  }

  return {
    showSnackbar,
    responseCode,
    responseMessage,
    toastTimeout,
    toastTimer,
    toastLink,
    toastLinkText,

    alert,
    success,
    error,
    reset,
  }
})
